module.exports = __webpack_public_path__ + "img/bul_arr_down.64c2b05f.svg";